import { apiUrl } from './api_config'

const API_BASE_URL = apiUrl('/users')
const LOGIN_ENDPOINT = `${API_BASE_URL}/login`
const RESET_PASSWORD_ENDPOINT = `${API_BASE_URL}/reset-password`

function isInactiveUser(user) {
  const status = user?.user_status ?? user?.status
  return (
    String(status ?? '')
      .trim()
      .toLowerCase() === 'inactive'
  )
}

export async function loginUser(email, password) {
  const response = await fetch(LOGIN_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_email: email, password: password }),
  })

  let payload = null
  try {
    payload = await response.json()
  } catch {
    // The server may return an empty body for an unsuccessful request.
  }

  if (!response.ok) {
    throw new Error(
      payload?.message || payload?.error || 'Invalid email or password.',
    )
  }

  const user = payload?.user || payload?.data?.user || payload?.data || payload
  if (!user || typeof user !== 'object') {
    throw new Error('The login response did not include a user.')
  }
  if (isInactiveUser(user)) {
    throw new Error('This account is inactive. Contact an administrator.')
  }

  return {
    user,
    token:
      payload?.token || payload?.accessToken || payload?.data?.token || null,
  }
}

export async function resetUserPassword(
  userId,
  currentPassword,
  newPassword,
  confirmPassword,
) {
  const response = await fetch(
    `${RESET_PASSWORD_ENDPOINT}/${encodeURIComponent(userId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      }),
    },
  )

  let payload = null
  try {
    payload = await response.json()
  } catch {
    // Preserve the status-based error when no JSON body is returned.
  }

  if (!response.ok) {
    throw new Error(
      payload?.message || payload?.error || 'Password reset failed.',
    )
  }

  return payload?.user || payload?.data?.user || payload?.data || payload
}
